import { render, staticRenderFns } from "./AdminEnquestes.vue?vue&type=template&id=17bd9d88&"
import script from "./AdminEnquestes.vue?vue&type=script&lang=js&"
export * from "./AdminEnquestes.vue?vue&type=script&lang=js&"
import style0 from "./AdminEnquestes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports